<template>
  <div class="product-Item">
    <div class="introduction_r">
      <div class="introduction_nameBox">
        <el-page-header @back="goBack" :content="contentName"></el-page-header>
      </div>
      <div class="introduction_cont" v-if="PageType == 1">
        <div class="videoBox">
          <div class="video-top">
            <div class="createTime">发布时间：{{videoInfo.createTime | dateFilter('YYYY-MM-DD')}}</div>
            <div class="numBer">浏览量：{{videoInfo.viewNum}}</div>
          </div>
          <div class="video">
            <video width="100%" height="100%" :src="videoInfo.videoLink" controls :poster="videoInfo.img"></video>
          </div>
        </div>
      </div>
      <div v-else class="introduction_cont" v-html="content"></div>
    </div>
  </div>
</template>

<script>
import utils from "../assets/js/util.js";
export default {
  data() {
    return {
      content: "",
      contentId:'',
      contentName:'',
      PageType:-1,
      videoInfo:{}
    };
  },
  created(){
    this.contentId = this.$route.query.contentId;
    this.contentName = this.$route.query.contentName;
    if(this.$route.query.PageType){
      // console.log(11111)
      this.PageType = this.$route.query.PageType;
    }
    // console.log(this.contentName)
    this.getContentInfo();
  },
  mounted() {
    let _this = this;
    utils.$on("getDatas",function(res){
      console.log(res)
      _this.contentId = res.contentId;
      _this.contentName = res.contentName;
      _this.getContentInfo();
    })
    console.log(utils)
  },
  methods: {
    goBack() {
      // history.go(-1)
      this.$router.go(-1);//返回上一层
      console.log(this)
      // location.reload()
    },
    getContentInfo() {
      if(this.PageType == 1){
        let url = "/videoController/back/searchVideoInfo"
        this.$axios.get(url,{
           params: {
            videoId: this.contentId
          }
        }).then(res=>{
          console.log(res)
          this.videoInfo = res.data.data;
        })
      }else{
        let url = "/navigationController/front/searchContentInfo";
        this.$axios.get(url, {
          params: {
            contentId: this.contentId,
          },
        })
        .then((res) => {
          console.log(res);
          const regex = new RegExp('<img', 'gi')
          this.content = res.data.data.content.replace(regex,`<img style="max-width: 100%; height: auto"`);
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.product-Item {
  width: 1200px;
  margin: 15px auto;
  .introduction_r {
    // width: calc(1200px - 304px);
    .introduction_nameBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px 0;
      // margin-bottom: 30px;
      border-bottom: 1px solid #e6e8ed;
      .introduction_name {
        font-size: 30px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #333333;
      }
      .inputBox {
        width: 360px;
        height: 36px;
        // background: #FFFFFF;
        border-radius: 4px;
        // border: 1px solid #1373CF;
      }
    }
    .introduction_cont {
      padding: 20px 0;
      min-height: 500px;
      .videoBox{
        .video-top{
          display: flex;
          align-items: center;
          justify-content: end;
          padding: 20px;
          .createTime{
            font-size: 14px;
            color: #666;
            margin-right: 32px;
          }
          .numBer{
            font-size: 14px;
            color: #666;
          }
        }
        .video{
          width: 100%;
          height: auto;
        }
      }
    }
  }
}
</style>